import { LogOutIcon } from 'lucide-react'
import { useT } from '@/session/useSession'
import { IconButton } from '../IconButton/IconButton'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'
import styles from './SidebarAccount.module.css'
import { useIsSidebarCollapsed } from './useSidebarCollapsed'

export function initialsOf(name: string): string {
  const [first = '', ...rest] = name.trim().split(/\s+/).filter(Boolean)
  const last = rest.at(-1) ?? ''

  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
}

export function SidebarAccount({ name, onSignOut }: { name: string; onSignOut: () => void }) {
  const t = useT()
  const rail = useIsSidebarCollapsed()

  const avatar = (
    <span className={styles.avatar} aria-hidden="true">
      {initialsOf(name)}
    </span>
  )

  return (
    <div className={styles.account} data-collapsed={rail ? '' : undefined}>
      {rail ? (
        <Tooltip>
          <TooltipTrigger render={avatar} />
          <TooltipContent side="right">{name}</TooltipContent>
        </Tooltip>
      ) : (
        avatar
      )}
      <p className={styles.status}>
        <span className={styles.label}>{t('layouts.main.signed_in_as')}</span>
        <span className={styles.name}>{name}</span>
      </p>

      <IconButton label={t('auth.logout')} side="right" onClick={onSignOut}>
        <LogOutIcon />
      </IconButton>
    </div>
  )
}
